import SeoHead from '@/components/SeoHead';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageToggle from '../../components/LanguageToggle';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title={lang === 'ar' ? 'سياسة الخصوصية - Debug' : 'Privacy Policy - Debug'}
        description={lang === 'ar' 
          ? 'اقرأ سياسة الخصوصية الخاصة بـ Debug. نحن نلتزم بحماية بياناتك وخصوصيتك الشخصية.' 
          : 'Read Debug\'s Privacy Policy. We are committed to protecting your personal data and privacy.'}
        keywords="privacy policy, data protection, personal information, cookies, user rights"
        canonical="https://debuging.com/privacy-policy"
        lang={lang}
      />
      {/* Navbar */}
      <nav className="bg-white shadow-lg fixed top-0 left-0 right-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/c83f6350fa782ce29b612b38d2cee1d4/3b7550d6c06eea93242f62b6efa2ff71.png" 
                alt="Debug Logo" 
                title="Debug - Software Development Company"
                className="h-10 w-auto"
              />
            </Link>

            <div className="flex items-center gap-4">
              <LanguageToggle />
              <Link 
                to="/"
                className="bg-[rgb(0,0,139)] text-white px-6 py-2 rounded-lg font-semibold hover:bg-[rgb(0,0,100)] transition-all cursor-pointer whitespace-nowrap"
              >
                {t('backToHome')}
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-32 pb-20 px-4">
        <article className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">{t('privacyPolicy')}</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('informationCollection')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('informationCollectionText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('howWeUseInfo')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('howWeUseInfoText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('dataSecurity')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('dataSecurityText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('yourRights')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('yourRightsText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookies')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('cookiesText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('contactUs')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('contactUsText')}</p>
            </section>
          </div>
        </article>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}